import { isNullOrUndefined } from 'app/utils/object.utils';
import { AssignmentLoadPriorityEnum } from './assignment-api.model';

export enum DeliveryStatusEnum {
  new = 'New',
  assigned = 'Assigned',
  rejected = 'Rejected',
  inProgress = 'InProgress',
  finished = 'Finished',
  canceled = 'Canceled',
}

export const DeliveryStatusEnumMap = {
  [DeliveryStatusEnum.new]: {
    index: 0,
    translateKey: 'new',
    cssClass: 'status--new',
  },
  [DeliveryStatusEnum.assigned]: {
    index: 1,
    translateKey: 'assigned',
    cssClass: 'status--assigned',
  },
  [DeliveryStatusEnum.rejected]: {
    index: 2,
    translateKey: 'rejected',
    cssClass: 'status--rejected',
  },
  [DeliveryStatusEnum.inProgress]: {
    index: 3,
    translateKey: 'in_progress',
    cssClass: 'status--in-progress',
  },
  [DeliveryStatusEnum.finished]: {
    index: 4,
    translateKey: 'status_finished',
    cssClass: 'status--finished',
  },
  [DeliveryStatusEnum.canceled]: {
    index: 5,
    translateKey: 'canceled',
    cssClass: 'status--canceled',
  },
};

export const isDeliveryEditable = (delivery: DeliveryApiModel): boolean =>
  isNullOrUndefined(delivery?.exportBatchId) ||
  delivery?.exportStatus !== DeliveryExportStatusEnum.exported;

export const getDeliveryStatusByIndex = (index: any): DeliveryStatusEnum => {
  index = index ? parseInt(index, 10) : 0;
  return (
    (Object.keys(DeliveryStatusEnumMap).find(
      (key) => DeliveryStatusEnumMap[key].index === index
    ) as DeliveryStatusEnum) || null
  );
};

export class DeliveryExportStatusCountModel {
  status: DeliveryExportStatusEnum;
  count: number;
}

export enum DeliveryExportStatusEnum {
  new = 'New',
  ok = 'OK',
  onHold = 'OnHold',
  rejected = 'Rejected',
  excluded = 'Excluded',
  noExport = 'NoExport',
  exported = 'Exported',
}

export const DeliveryExportStatusEnumMap = {
  [DeliveryExportStatusEnum.new]: {
    index: 0,
    translateKey: 'new',
  },
  [DeliveryExportStatusEnum.ok]: {
    index: 10,
    translateKey: 'ok',
  },
  [DeliveryExportStatusEnum.onHold]: {
    index: 20,
    translateKey: 'on_hold',
  },
  [DeliveryExportStatusEnum.rejected]: {
    index: 90,
    translateKey: 'rejected',
  },
  [DeliveryExportStatusEnum.excluded]: {
    index: 99,
    translateKey: 'excluded',
  },
  [DeliveryExportStatusEnum.noExport]: {
    index: 80,
    translateKey: 'no_export',
    static: true,
  },
  [DeliveryExportStatusEnum.exported]: {
    index: 60,
    translateKey: 'exported',
    hidden: true,
    static: true,
  },
};

export const getDeliveryExportStatusByIndex = (
  index: any
): DeliveryExportStatusEnum => {
  index = typeof index !== 'undefined' ? parseInt(index || 0, 10) : 80;
  return (
    (Object.keys(DeliveryExportStatusEnumMap).find(
      (key) => DeliveryExportStatusEnumMap[key].index === index
    ) as DeliveryExportStatusEnum) || null
  );
};

export class DeliveryApiModel {
  number: string;
  assignmentNumber: number;
  assignmentComment: number;
  orderLineNumber: string;
  orderNumber: number;
  vehicleName: number;
  vehicleNumber: string;
  vehiclePlateNumber: number;
  vehicleTypeName: number;
  driverName: number;
  customerId: number;
  customerName: number;
  customerNumber: number;
  customerProjectId: number;
  customerProjectName: number;
  customerProjectNumber: number;
  projectId: number;
  projectName: string;
  projectNumber: number;
  productTypeName: number;
  productGroupName: number;
  loadingTimePriority: AssignmentLoadPriorityEnum;
  loadingSiteComment: string;
  unloadingTimePriority: AssignmentLoadPriorityEnum;
  unloadingSiteComment: string;
  quantityLoaded: number;
  quantityDelivered: number;
  deliveryId: number;
  deliveryExtId: number;
  deliveryKey: string;
  productTypeId: number;
  productTypeExtId: number;
  driverId: number;
  driverExtId: number;
  assignmentId: number;
  assignmentExtId: number;
  vehicleId: number;
  vehicleExtId: number;
  quantity: number;
  unitId: number;
  unitExtId: number;
  isReturnDelivery: boolean;
  isTrailerUsed: boolean;
  isUsedForInvoice: boolean;
  deliveryStart: Date; // start time
  deliveryEnd: Date; // finish time
  loadingDateTime: Date; // load time
  loadingSiteId: number;
  loadingSiteName: string;
  loadingSiteExtId: number;
  loadingAddress: string;
  loadingCustomerProjectId: number;
  unloadingDateTime: Date; // delivery time
  unloadingSiteId: number;
  unloadingSiteName: string;
  unloadingSiteExtId: number;
  unloadingAddress: string;
  unloadingCustomerProjectId: number;
  pauseTime: number;
  pauseComment: number;
  waitingTime: number;
  waitingComment: number;
  externalComment: number;
  contactPerson: string;
  contactPersonPhone: string;
  distance: number;
  status: string;
  exportStatus: string;
  exportComment: string;
  exportBatchId?: number;
  exportDateTime?: Date;
  isActive: boolean;
  supplierName: string;
  createUser: string;
  terminalTransactionId: number;
  terminalTransactionExtId: string;
  deliveryVehicleTypeId: number;
  deliveryVehicleTypeExtId: string;
  loadAddressId: number;
  unloadAddressId: number;
}

export class DeliveryModel extends DeliveryApiModel {}

export class DeliveriesResponseModel {
  results: DeliveryApiModel[];
  count: number;
}
